// Called by : src/components/question/Question.vue

<template>
  <base-modal ref="base-modal" pageId="pge_dico" pageClass="dico" modalClass="modal-lg" modalDataBack="true" modalDataKey="true" :key="keyModal">

    {{ forceUpdate }}

    <template #header>
      <h4 class="modal-title" id="pge_about_title">
        <img :src="constants.assets.iconLecDicoWhite" alt="icon-dictionary" class="icn_lec_dico mr-2">
        {{ $t('infos.dicoTitle') }}
      </h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <template #body>
      <div class="lesson_dico list-group">
        <div class="dico_item list-group-item" v-for="dico in dictionary" :key="dico.xid">
          <h4>{{ dico.term }}</h4>
          <p>{{ dico.defi }}</p>
          <small><a :href="dico.link" target="_blank">{{ dico.link }}</a></small>
        </div>
      </div>
    </template>

    <template #footer>
      <button type="submit" class="btn btn-secondary btn-lg btn-block" data-dismiss="modal">
        <span class="oi oi-x mr-2"></span>
        {{ $t('modals.close') }}
      </button>
    </template>

  </base-modal>
</template>

<script>
import { constants } from '@/constants'
import BaseModal from '@/components/BaseModal'
import SoundPlayer from '@/components/misc/SoundPlayer'

export default {
  components: {
    BaseModal,
    SoundPlayer,
  },
  props: {
    dictionary: Array,
  },
  data() {
    return {
      keyModal: false,
    }
  },
  methods: {
    getKey(sId) {
      this.answer = [];
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
  },
  computed: {
    forceUpdate() {
      if (!this.keyModal) this.keyModal = this.getKey('ModalMcq');
      return '';
    },
    constants() {
      return constants
    },
  },
  mounted: function() {
    this.keyModal = false;
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/misc/ModalDico.vue